import { Component } from 'react';
import ErrorState from 'common/ErrorState/ErrorState';

/**
 * Межа помилок рендеру.
 *
 * Мережеві збої обробляють самі сторінки; сюди потрапляє те, чого вони не
 * очікують: виняток у рендері або в обробнику. Без цієї межі React знімає з
 * екрана все дерево, і користувач бачить білу сторінку без жодного пояснення.
 *
 * Скидається за ключем: App передає сюди поточний шлях, тому перехід на іншу
 * сторінку виводить застосунок зі стану помилки. Інакше одна зламана сторінка
 * лишалася б на екрані до перезавантаження вкладки.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('Помилка рендеру:', error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    const language = window.localStorage.getItem('language') === 'en' ? 'en' : 'ua';

    return (
      <div className='container section'>
        <ErrorState
          variant='page'
          error={{ kind: 'unknown', status: null }}
          onRetry={() => window.location.reload()}
        >
          {language === 'en'
            ? 'The page could not be displayed. Reloading usually helps.'
            : 'Не вдалося показати сторінку. Зазвичай допомагає перезавантаження.'}
        </ErrorState>
      </div>
    );
  }
}
